export const zaytun = {
  brand: "#123F31",
  brandHover: "#17694D",
  accent: "#1E5BA8",
  gold: "#D6B867",
  success: "#17845F",
  warning: "#A66B12",
  danger: "#D94668",
  info: "#2563B8",
  light: {
    bg: "#F7F8F7",
    surface: "#FFFFFF",
    muted: "#F3F5F4",
    text: "#18231F",
    secondary: "#56635D",
    border: "#E6EAE8",
  },
  dark: {
    bg: "#0C1411",
    surface: "#111D18",
    muted: "#192720",
    text: "#F1F5F3",
    secondary: "#B7C2BD",
    border: "#24372F",
  },
  spacing: [4, 8, 12, 16, 20, 24, 32, 40, 48, 64],
  radius: { xs: 8, sm: 10, md: 14, lg: 18, xl: 24, shell: 30 },
  breakpoints: { xs: 0, sm: 600, md: 768, lg: 992, xl: 1200 },
  motion: { fast: 120, menu: 180, dialog: 220 },
} as const;
